import api from "api";
import { useQuery } from "react-query";
import { Country } from "utils/market";
import { queryKeys } from "utils/misc";

export enum Category {
  id = "id",
  name = "name",
  phone = "phone_number",
  email = "email",
  uid = "uid",
  nhs_number = "nhs_number",
}

export interface Vars {
  country: Country;
  category: Category;
  search: string;
  pageLimit?: number;
  pageBefore?: unknown;
  pageAfter?: unknown;
}

const useListPatients = (params: Vars) => {
  const { country, category, search, pageLimit, pageBefore, pageAfter } = params;
  const key = queryKeys.patientSearch(params);

  return useQuery(
    key,
    async () => {
      const isUID = category === Category.uid;
      const isSE = country === Country.SE;
      const shouldOverrideUID = isUID && !isSE;
      const cat = shouldOverrideUID ? "birthday" : category;

      const query: any = {
        [cat]: search,
        country: country,
      };

      if (pageLimit) {
        query["page[limit]"] = pageLimit;
      }
      if (pageBefore) {
        query["page[before]"] = pageBefore;
      }
      if (pageAfter) {
        query["page[after]"] = pageAfter;
      }

      return api.parse("GET /patients", { query });
    },
    { enabled: !!search }
  );
};

export default useListPatients;
